<script setup lang="ts">

const userStore = useUserStore();
</script>

<template>
  <nuxt-link
    v-if="Boolean(userStore.user)"
    :to="{ path: '/profile', hash: '#loyalty' }"
    class="loyalty-header-button"
  >
    Бонусы <span class="loyalty-header-button__bonuses">{{ userStore.user.bonus_amount || 0 }}</span>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.loyalty-header-button {
  padding: 4px 5px 4px 12px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  background-color: $background-accent-4;
  border-radius: 12px;
  align-items: center;
  min-width: 100px;
  min-height: 38px;

  .loyalty-header-button__bonuses {
    padding: 4px 8px;
    background-color: #f6f6fd;
    border-radius: 8px;
  }
}
</style>
